import React, { useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Icon } from 'foundations-library/components'
import { Dialog } from 'functional-foundations'

const useStyles = makeStyles({
    demoDialog: {
        '& .dialog-container': {
            padding: '0 !important'
        },
        '& .close-dialog-x': {
            display: 'none'
        }
    },
    videoModalContent: {
        position: 'relative',
        width: '1280px',
        height: '720px',
        backgroundColor: '#000000',
        overflow: 'hidden',
        '&:fullscreen': {
            width: '100vw',
            height: '100vh'
        },
        '& iframe': {
            display: 'block',
            width: '100%',
            height: '100%',
            border: 'none'
        }
    },
    videoControlButton: {
        position: 'absolute',
        top: '35px',
        zIndex: 2,
        width: '44px',
        height: '44px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '999px',
        border: '1px solid rgba(255, 255, 255, 0.15)',
        background: 'rgba(20, 20, 20, 0.72)',
        cursor: 'pointer'
    },
    fullscreenButton: {
        right: '72px'
    },
    closeButton: {
        right: '20px'
    }
})

type PropsType = {
    isOpen: boolean
    onClose(): void
}

/**
 * Shared SMS registration demo video dialog.
 */
const WatchDemoDialog = ({ isOpen, onClose }: PropsType): React.ReactElement => {
    const classes = useStyles()
    const videoModalRef = useRef<HTMLDivElement | null>(null)

    const closeDemoModal = async () => {
        if (document.fullscreenElement && typeof document.exitFullscreen === 'function') {
            await document.exitFullscreen()
        }

        onClose()
    }

    const toggleVideoFullscreen = async () => {
        if (!videoModalRef.current || typeof videoModalRef.current.requestFullscreen !== 'function') {
            return
        }

        if (document.fullscreenElement === videoModalRef.current && typeof document.exitFullscreen === 'function') {
            await document.exitFullscreen()
            return
        }

        await videoModalRef.current.requestFullscreen()
    }

    return (
        <Dialog
            isOpen={isOpen}
            onClose={closeDemoModal}
            width={1280}
            className={classes.demoDialog}
            closeOnClickOutside
            data-testid='watch-demo-dialog'
        >
            {isOpen && (
                <div className={classes.videoModalContent} ref={videoModalRef}>
                    <button
                        type='button'
                        className={`${classes.videoControlButton} ${classes.fullscreenButton}`}
                        onClick={toggleVideoFullscreen}
                        aria-label='Toggle fullscreen video'
                        data-testid='watch-demo-dialog-fullscreen-button'
                    >
                        <Icon name='open-in-new-alt' color='white' size={20}/>
                    </button>
                    <button
                        type='button'
                        className={`${classes.videoControlButton} ${classes.closeButton}`}
                        onClick={closeDemoModal}
                        aria-label='Close demo video dialog'
                        data-testid='watch-demo-dialog-video-close-button'
                    >
                        <Icon name='close' color='white' size={20}/>
                    </button>
                    <iframe
                        src='https://www.youtube.com/embed/Bp9HVG3xVLs?fs=0'
                        title='SMS Registration Demo'
                        frameBorder='0'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                        allowFullScreen
                    />
                </div>
            )}
        </Dialog>
    )
}

export default WatchDemoDialog
